module.exports = {"email":"E-Mail","placeholder":"Gib deine E-Mail-Adresse ein","accept_privacy":"Durch die Übermittlung der Daten akzeptiere ich die","accept_privacy_link":"Datenschutzerklärung","ensure_correct":"Bist du sicher, dass diese E-Mail korrekt ist?","example":"Beispiel: {{email}}"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/email.json
// module id = 483
// module chunks = 248 1695